function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { getCurrentInstance, inject, ref, unref, watch } from 'vue';
import '../../../../utils/index.mjs';
import '../../../../hooks/index.mjs';
import { isValidRange, getDefaultValue } from '../utils.mjs';
import { ROOT_PICKER_INJECTION_KEY } from '../constants.mjs';
import { useShortcut } from './use-shortcut.mjs';
import { useNamespace } from '../../../../hooks/use-namespace/index.mjs';
import { useLocale } from '../../../../hooks/use-locale/index.mjs';
import { isArray } from '@vue/shared';
const useRangePicker = (props, _ref) => {
  let defaultValue = _ref.defaultValue,
    leftDate = _ref.leftDate,
    rightDate = _ref.rightDate,
    unit = _ref.unit,
    onParsedValueChanged = _ref.onParsedValueChanged;
  const _getCurrentInstance = getCurrentInstance(),
    emit = _getCurrentInstance.emit;
  const _inject = inject(ROOT_PICKER_INJECTION_KEY),
    pickerNs = _inject.pickerNs;
  const drpNs = useNamespace("date-range-picker");
  const _useLocale = useLocale(),
    t = _useLocale.t,
    lang = _useLocale.lang;
  const handleShortcutClick = useShortcut(lang);
  const minDate = ref();
  const maxDate = ref();
  const rangeState = ref({
    endDate: null,
    selecting: false
  });
  const handleChangeRange = val => {
    rangeState.value = val;
  };
  const handleRangeConfirm = function () {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const _minDate = unref(minDate);
    const _maxDate = unref(maxDate);
    if (isValidRange([_minDate, _maxDate])) {
      emit("pick", [_minDate, _maxDate], visible);
    }
  };
  const onSelect = selecting => {
    rangeState.value.selecting = selecting;
    if (!selecting) {
      rangeState.value.endDate = null;
    }
  };
  const restoreDefault = () => {
    const _getDefaultValue = getDefaultValue(unref(defaultValue), {
        lang: unref(lang),
        unit,
        unlinkPanels: props.unlinkPanels
      }),
      _getDefaultValue2 = _slicedToArray(_getDefaultValue, 2),
      start = _getDefaultValue2[0],
      end = _getDefaultValue2[1];
    minDate.value = void 0;
    maxDate.value = void 0;
    leftDate.value = start;
    rightDate.value = end;
  };
  watch(defaultValue, val => {
    if (val) {
      restoreDefault();
    }
  }, {
    immediate: true
  });
  watch(() => props.parsedValue, parsedValue => {
    if (isArray(parsedValue) && parsedValue.length === 2) {
      const _parsedValue = _slicedToArray(parsedValue, 2),
        start = _parsedValue[0],
        end = _parsedValue[1];
      minDate.value = start;
      leftDate.value = start;
      maxDate.value = end;
      onParsedValueChanged(unref(minDate), unref(maxDate));
    } else {
      restoreDefault();
    }
  }, {
    immediate: true
  });
  return {
    minDate,
    maxDate,
    rangeState,
    lang,
    ppNs: pickerNs,
    drpNs,
    handleChangeRange,
    handleRangeConfirm,
    handleShortcutClick,
    onSelect,
    t
  };
};
export { useRangePicker };